import { render, staticRenderFns } from "./PointsStatistics.vue?vue&type=template&id=554b656d&scoped=true"
import script from "./PointsStatistics.vue?vue&type=script&lang=js"
export * from "./PointsStatistics.vue?vue&type=script&lang=js"
import style0 from "./PointsStatistics.vue?vue&type=style&index=0&id=554b656d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b656d",
  null
  
)

export default component.exports